export default {
  'it-IT': {
    topBrands: 'Top brand',
    brands: 'brand',
  },
  'fr-FR': {
    topBrands: 'Les meilleures marques',
    brands: 'marques',
  },
  'es-ES': {
    topBrands: 'Las principales marcas',
    brands: 'marcas',
  },
  'en-GB': {
    topBrands: 'Top brands',
    brands: 'brands',
  },
  'en-US': {
    topBrands: 'Top brands',
    brands: 'all-brands',
  },
  'de-DE': {
    topBrands: 'Top marken',
    brands: 'marken',
  },
  'en-AU': {
    topBrands: 'Top brands',
    brands: 'brands-1',
  },
  'ja-JP': {
    topBrands: 'Top brands',
    brands: '',
  },
  'ko-KR': {
    topBrands: 'Top brands',
    brands: '',
  },
};
